import React, { useState } from 'react';
import { useHelpCards } from '../lib/useHelpCards';
import { HelpCard as IHelpCard } from '../types/helpCard.types';
import HelpCard from './HelpCard';

interface Props {
  data?: IHelpCard[];
}

const HelpCards = ({ data }: Props) => {
  const [expandedCardId, setExpandedCardId] = useState<string | null>(null);
  const { cards: defaultCards } = useHelpCards();
  const cardsData = data || defaultCards;

  const handleToggle = (cardId: string) => {
    setExpandedCardId(expandedCardId === cardId ? null : cardId);
  };

  return (
    <div className="space-y-4 pb-3 text-start">
      {cardsData.map((card, index) => (
        <HelpCard
          key={card.id}
          data={card}
          isExpanded={expandedCardId === card.id}
          onToggle={handleToggle}
          iconIndex={index}
        />
      ))}
    </div>
  );
};

export default HelpCards;
